import React from 'react';
import DivisorForm from './DivisorForm';

interface Document {
  id: number;
  name: string;
  divisor_types?: string[]; // optional fallback
}

interface ExtractJob {
  id: number;
  job_id: string;
  name?: string;
}

interface Divisor {
  id: number;
  divisor_type: string;
  title: string;
  content_preview: string;
  parent_id?: number | null;
  metadata?: any;
}

interface ParentDivisor { id: number; title: string; }

interface DivisorEditProps {
  document: Document;
  extractJob: ExtractJob;
  divisor: Divisor;
  parentDivisors: ParentDivisor[];
  errors: Record<string, string[]>;
  /** Canonical list from server (DivisorType.all_types) */
  divisorTypes?: string[];
}

export default function DivisorEdit({
  document,
  extractJob,
  divisor,
  parentDivisors,
  errors,
  divisorTypes
}: DivisorEditProps) {
  // Always provide a safe, normalized list
  const safeDivisorTypes: string[] = (divisorTypes ?? document.divisor_types ?? []).map(String);

  return (
    <DivisorForm
      document={document}
      extractJob={extractJob}
      divisor={divisor}
      parentDivisors={parentDivisors}
      isEdit={true}
      errors={errors}
      divisorTypes={safeDivisorTypes}
    />
  );
}
